<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="saveStep()">
            <h3>Edit Step</h3>
            <div class="modal-content">
                <div class="field">
                    <select v-model="step.action" class="narrow">
                        <option value="email">Send email</option>
                    </select> &nbsp;
                    <input type="number" v-model="step.delta" class="narrow"> &nbsp;
                    <select class="narrow">
                        <option>days after being added to the campaign</option>
                    </select>
                </div>

                <div class="field">
                    <input v-model="message.subject" type="text" placeholder="Subject...">
                </div>

                <div class="field">
                    <textarea v-model="message.body" class="tall" placeholder="Your message..."></textarea>
                </div>

                <div class="field">
                    <select v-model="step.status">
                        <option value="draft">Draft</option>
                        <option value="publish">Published</option>
                    </select>
                </div>
            </div>
            <div class="modal-actions">
                <a @click="removeStep()" href="javascript:;" class="float-left">
                    <font-awesome-icon icon="trash" />
                </a>
                <a @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <button>Save Step</button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    props: ['app'],
    data() {
        return {
            show: false,
            internalDelta: 0,
            step: undefined,
            funnel: undefined
        };
    },
    computed: {
        message() {
            var _ = this;
            return _.step.message || {};
        }
    },
    methods: {
        saveStep() {
            var _ = this;

            _.app.requester.request({
                controller: 'funnels',
                action: 'save',
                funnel: _.funnel
            });

            _.show = false;
        },

        removeStep() {
            var _ = this;

            if (confirm('Are you sure you want to remove this step?')) {
                _.show = false;
                _.funnel.steps.splice(_.funnel.steps.indexOf(_.step), 1);
                _.saveStep();
            }
        }
    }
};
</script>
